class StickyATC {
    constructor() {
        const atc = document.querySelector(".product-form button[data-add-to-cart]");
        this.sticky = document.querySelector("#sticky-atc");
        this.formAtc = atc;
        this.picker = this.sticky?.querySelector(".sticky-atc__variants");
        this.button = this.sticky?.querySelector("[data-sticky-add-to-cart]");
        this.scrollY = window.scrollY;
        
        if (!atc || !this.sticky || !this.button) {
            return;
        }

        this.addToCartHtml = this.formAtc.disabled
            ? '<span class="plus">+</span> Add to bag'
            : this.button.innerHTML;

        const observer = new IntersectionObserver(([entry]) => {
            this.sticky.hidden = entry.isIntersecting;
        }, { threshold: 0 });

        observer.observe(atc);

        this.syncButton();
        this.button?.addEventListener("click", () => this.handleClick());
        this.picker?.addEventListener("change", (e) => this.handleVariantClick(e));
        document.addEventListener("scroll", () => this.collapsePickerOnScroll(), { passive: true });
}

    collapsePickerOnScroll() {
        const currY = window.scrollY;
        const isScrollingUp = currY < this.lastScrollY;
        const pickerOpen = this.picker && !this.picker.hidden;

        this.lastScrollY = currY;
    
        if (!isScrollingUp || !pickerOpen) return;

        this.picker.hidden = true;
        this.syncButton();
    }

    handleClick() {
        if (!this.sticky.hasAttribute("data-has-variants")) {
            this.formAtc.click();
            return;
        }
    
        if (this.picker.hidden) {
            this.picker.hidden = false;
            this.syncFormVariant();
            return;
        }
    
        if (this.formAtc.disabled) return;
        this.syncFormVariant();
        this.formAtc.click();
    }

    syncButton() {
        const pickerOpen = this.picker && !this.picker.hidden;
    
        if (this.sticky.hasAttribute("data-has-variants") && !pickerOpen) {
            this.button.disabled = false;
            this.button.innerHTML = this.addToCartHtml;
            return;
        }
    
        this.button.disabled = this.formAtc.disabled;
        this.button.innerHTML = this.formAtc.innerHTML;
    }

    handleVariantClick(e) {
        const option = e.target.closest("[data-sticky-variant]");
        if (!option) return;
        
        this.syncFormVariant(option);
    }

    syncFormVariant(input = this.picker.querySelector("[data-sticky-variant]:checked")) {
        if (!input) return;

        const radio = document.querySelector(
            `.product-form input[name="id"][value="${input.dataset.stickyVariant}"]`
        );

        if (!radio) return;

        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true}));

        this.syncButton();
    }
}

new StickyATC();